"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.advCreateApi = advCreateApi;
exports.advDeleteApi = advDeleteApi;
exports.advDetailApi = advDetailApi;
exports.advListApi = advListApi;
exports.advUpdateApi = advUpdateApi;
exports.getEnableAdvertisementListApi = getEnableAdvertisementListApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 广告列表
 * @param params
 */
function advListApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/advertisement/page',
    method: 'GET',
    params: params
  });
}

/**
 * 新增广告
 * @param data
 */
function advCreateApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/advertisement/save',
    method: 'POST',
    data: data
  });
}

/**
 * 编辑广告
 * @param data
 */
function advUpdateApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/advertisement/update',
    method: 'POST',
    data: data
  });
}

/**
 * 删除广告
 */
function advDeleteApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/advertisement/delete/".concat(id),
    method: 'DELETE'
  });
}

/**
 * 广告详情
 * @param id
 */
function advDetailApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/advertisement/detail/".concat(id),
    method: 'GET'
  });
}

/**
 * 获取所有启用状态的广告
 */
function getEnableAdvertisementListApi() {
  return (0, _request.default)({
    url: '/admin/platform/advertisement/list/enable',
    method: 'GET'
  });
}